import {
  FlatType,
  FloorType,
  State,
  StreetType,
} from '@energy-retailer/constants';
import { z } from 'zod';

export const fluxAddressSchema = z.object({
  full: z.string().min(1),
  suburb: z.string().min(1),
  postcode: z.string().min(1),
  region: z.nativeEnum(State),
  house_number: z.number().optional(),
  house_number_suffix: z.string().optional(),
  au_house_number_to: z.number().optional(),
  au_house_number_to_suffix: z.string().optional(),
  country: z.string().min(1),
  street_name: z.string().min(1),
  street_type: z.nativeEnum(StreetType),
  property_name: z.string().optional(),
  building_or_property_name_1: z.string().optional(),
  building_or_property_name_2: z.string().optional(),
  lot_number: z.string().optional(),
  flat_number: z.string().optional(),
  flat_type: z.nativeEnum(FlatType).optional(),
  floor_number: z.string().optional(),
  floor_type: z.nativeEnum(FloorType).optional(),
  street_suffix: z.string().optional(),
});

export type FluxAddressSchema = z.infer<typeof fluxAddressSchema>;
